import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource, MatDialog, MatDialogConfig, MatSnackBar, MatSnackBarConfig} from '@angular/material';

import { Subject } from '../shared/model/subject.model';
import { SubjectMatter } from '../shared/subject-matter.model';
import { SelectSubjectsDialogComponent } from 'src/app/core/modal/select-subjects-dialog/select-subjects-dialog.component';
import { RequestSubjectsComponent } from '../request-subjects/request-subjects.component';
import { SnackbarMessageComponent } from 'src/app/core/snackbar-message/snackbar-message.component';



@Component({
  selector: 'app-subjects-history',
  templateUrl: './subjects-history.component.html',
  styleUrls: ['./subjects-history.component.scss']
})
export class SubjectsHistoryComponent implements OnInit {

  displayedColumns = ['findColumn', 'codMateria', 'materia', 'codPrograma', 'nombrePrograma', 'periodo',
  'calificacion', 'comentario', 'actionsColumn' ];
  dataSource;
  subjectsHistory: Subject[] = [];
  @Input() subjectsMatter: SubjectMatter[] = [];
  @Output() setMessage: EventEmitter<any> = new EventEmitter();


  constructor(private dialog: MatDialog, private snackBar: MatSnackBar ) { }

  ngOnInit() {
    this.insertSubjectH();
    this.setMessage.emit('');
  }

  clean() {
    this.subjectsHistory = [];
    this.insertSubjectH();
  }

  deleteSubjectH(item) {
    this.subjectsHistory.splice(item, 1);
    this.dataSource = new MatTableDataSource(this.subjectsHistory);
  }

  insertSubjectH() {
    this.setMessage.emit('');
    const subject = new Subject();
    this.subjectsHistory.push(subject);
    this.dataSource = new MatTableDataSource(this.subjectsHistory);
  }

  openDialog(subject) {
    this.setMessage.emit('');
        // const index =  this.dataSource.filteredData.indexOf(subject);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { subjectsMatter: this.subjectsMatter, index: subject};
    dialogConfig.width = '65%';
    const dialogRef = this.dialog.open(SelectSubjectsDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
        if (value !== null) {
          if (this.validateSubjectsHistory(value.subject.materia.codigo)) {
            this.subjectsHistory[value.index].codMateria = value.subject.materia.codigo;
            this.subjectsHistory[value.index].materia = value.subject.materia.nombre;
            this.subjectsHistory[value.index].codPrograma = value.subject.programa.codigo;
            this.subjectsHistory[value.index].nombrePrograma = value.subject.programa.nombre;
            this.subjectsHistory[value.index].version = value.subject.programa.version;
            this.subjectsHistory[value.index].periodo = value.subject.semestre;
            this.subjectsHistory[value.index].intensidad = value.subject.intensidadHoraria;
            this.subjectsHistory[value.index].calificacion = value.subject.calificacion;
            this.subjectsHistory[value.index].institucion = 1201;
            this.subjectsHistory[value.index].creditos = value.subject.nroCreditos;
          } else {
            const message = 'La materia ' + value.subject.materia.nombre + ' ya fue seleccionada';
            this.setMessage.emit(message);
          }
        }
    });
  }

  private validateSubjectsHistory(value): boolean {
    let result = true;
    this.subjectsHistory.forEach(element => {
      if (element.codMateria === value) {
        result = false;
      }
    });
    return result;
  }
}
